import React, { useState } from 'react';
import {
    Box,
    Button,
    Checkbox,
    CheckboxGroup,
    FormControl,
    FormLabel,
    Icon,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text
} from '@chakra-ui/react';
import { VscAdd } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { createRol, getRoles } from '../../features/rolSlice';

export const ModalAgregarRol = ({ page, perPage }) => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const initialValues = {
        key: '',
        descripcion: '',
        estado: true,
        permisos: []
    };

    const [indice, setIndice] = useState(initialValues);

    const handleModalOpen = () => setIsModalOpen(true);
    const handleModalClose = () => {
        setIsModalOpen(false);
        setIndice(initialValues);
    };

    const handleSave = () => {
        dispatch(createRol(indice)).then(() => {
            dispatch(getRoles({ page, perPage }));
            setIsModalOpen(false);
            setIndice(initialValues);
        });
    };

    const handlePermisosChange = (newPermisos) => {
        setIndice({ ...indice, permisos: newPermisos });
    };

    // Permisos agrupados por módulo
    const modulos = [
        {
            titulo: "Configuraciones Básicas",
            permisos: [
                { label: "Ver Ciudad", value: "ver_modulo_ciudad" },
                { label: "Ver Pais", value: "ver_modulo_pais" },
                { label: "Ver usuario", value: "ver_modulo_usuario" },
                { label: "Ver Persona", value: "ver_modulo_persona" },
                { label: "Ver Servicio", value: "ver_modulo_servicio" },
                { label: "Ver Roles ", value: "ver_modulo_rol" },
                { label: "Ver Permisos ", value: "ver_modulo_permiso" },
                { label: "Ver Configuraciones ", value: "ver_modulo_configuraciones" },
                { label: "Ver Cliente", value: "ver_modulo_cliente" },
            ]
        },
        {
            titulo: "Módulo de Factura",
            permisos: [
                { label: "Ver Factura", value: "ver_modulo_factura" },
                { label: "Crear", value: "crear_factura" },
                { label: "Eliminar", value: "eliminar_factura" },
                { label: "Editar", value: "editar_factura" },
                { label: "Detalles", value: "detalle_factura" },
                { label: "Reporte pdf", value: "generar_factura_pdf" },
            ]
        }
    ];

    // Maneja el check/uncheck de todos los permisos de un módulo
    const togglePermisosModulo = (moduloPermisos, checked) => {
        const current = new Set(indice.permisos);
        moduloPermisos.forEach(p => {
            if (checked) {
                current.add(p.value);
            } else {
                current.delete(p.value);
            }
        });
        setIndice({ ...indice, permisos: Array.from(current) });
    };

    return (
        <>
            <Button
                colorScheme="blue"
                _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" }}}
                aria-label="Agregar"
                leftIcon={<Icon as={VscAdd} fontSize="lg" />}
                variant="solid"
                rounded={'xl'}
                onClick={handleModalOpen}
            >
                Nuevo Registro
            </Button>

            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay 
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">AGREGAR NUEVO ROL</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack spacing={4} p={4}>
                            <Stack direction={{ base: "column", lg: "row"}} spacing={4}>
                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                                    <Input
                                        placeholder="Ingrese el nombre del rol"
                                        type="text"
                                        value={indice.key}
                                        onChange={(e) => setIndice({ ...indice, key: e.target.value })}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold">DESCRIPCION</FormLabel>
                                    <Input
                                        placeholder="Ingrese la descripción del rol"
                                        type="text"
                                        value={indice.descripcion}
                                        onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                                    />
                                </FormControl>
                            </Stack>

                            {/* Módulos con permisos */}
                            {modulos.map((modulo, idx) => {
                            const todosSeleccionados = modulo.permisos.every(p => indice.permisos.includes(p.value));

                            return (
                                <Box
                                    key={idx}
                                    borderWidth="1px"
                                    borderRadius="xl"
                                    p={4}
                                    mt={4}
                                    _dark={{ borderColor: "gray.700", bg: "gray.900" }}
                                    bg="gray.50"
                                >
                                    <Stack
                                        direction="row"
                                        justify="space-between"
                                        align="center"
                                        mb={2}
                                        flexWrap="wrap"
                                    >
                                        <Text fontSize="lg" fontWeight="bold" color="blue.600">
                                            {modulo.titulo}
                                        </Text>

                                        <Checkbox
                                            isChecked={todosSeleccionados}
                                            onChange={(e) => togglePermisosModulo(modulo.permisos, e.target.checked)}
                                            colorScheme="blue"
                                        >
                                            Marcar todas
                                        </Checkbox>
                                    </Stack>

                                    <CheckboxGroup
                                        value={indice.permisos}
                                        onChange={handlePermisosChange}
                                        colorScheme="blue"
                                    >
                                        <Stack spacing={2} direction="row" flexWrap="wrap">
                                            {modulo.permisos.map((permiso, i) => (
                                                <Checkbox key={i} value={permiso.value}>
                                                    {permiso.label}
                                                </Checkbox>
                                            ))}
                                        </Stack>
                                    </CheckboxGroup>
                                </Box>
                            );
                        })}
                        </Stack>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme="red" _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }} size="lg" mr={3} onClick={handleModalClose} borderRadius="xl">
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="blue"
                            _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleSave}
                            borderRadius="xl"
                            disabled={!indice.key.trim() || !indice.descripcion}
                        >
                            GUARDAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};
